<template>
  <div id="system-manager">
    <v-card id="system_manager" class="setup-card">
      <v-card-title>
        <span class="main_card_title">{{ $i18n.t('pages.system.system_management.advanced_options') }}</span>
      </v-card-title>
      <v-card-text style="padding: 0 16px 25px 16px">
        <div class="height_56px" style="display: flex; align-items: center">
          <v-btn
            class="white--text mr-1 ml-1"
            color="#DBEAF1"
            elevation="0"
            height="42"
            @click="send_system_reload_message"
          >
            <span class="main_color button-font">{{ $i18n.t('general.system_reboot') }}</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {common_funcs} from "@/mixins/common";

export default {
  name: "SystemManager",
  mixins: [common_funcs],
  data: function () {
    return {

    }
  },
  methods: {
  }
}
</script>

<style>
.setup-card {
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(138, 138, 138, 0.15) !important;
  border-radius: 8px;
  elevation: 0;
}
</style>